export * from './BooksLibraryIcon';
export * from './BooksLibraryIcon16Light';
export * from './BooksLibraryIcon16Regular';
export * from './BooksLibraryIcon16Solid';
export * from './BooksLibraryIcon20Light';
export * from './BooksLibraryIcon20Regular';
export * from './BooksLibraryIcon20Solid';
export * from './BooksLibraryIcon24Regular';
export * from './BooksLibraryIcon24Solid';
export * from './BooksLibraryIcon32Regular';
export * from './BooksLibraryIcon64Regular';
